import { TYPES } from './types';
import { k3scriptService } from '../services';

// Get all scripts
export const getK3Scripts = (query = {}) => async dispatch => {
  try {
    const res = await k3scriptService.getK3Scripts(query);
    dispatch({
      type: TYPES.ACTION_GET_K3SCRIPTS_SUCCESS,
      payload: {
        scripts: res.data.data.scripts,
        total: res.data.data.total || res.data.data.scripts.length
      }
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3SCRIPTS_FAIL,
      payload: err.response?.data || { message: 'Error getting scripts' }
    });
  }
};

// Get a single script
export const getK3Script = (id) => async dispatch => {
  try {
    const res = await k3scriptService.getK3Scripts(id);
    dispatch({
      type: TYPES.ACTION_GET_K3SCRIPT_SUCCESS,
      payload: res.data.data.scripts[0]
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3SCRIPT_FAIL,
      payload: err.response?.data || { message: 'Error getting script' }
    });
  }
};

// Set scripts (create/update/delete)
export const setK3Scripts = (scripts, query = {}) => async dispatch => {
  try {
    const res = await k3scriptService.setK3Scripts(scripts, query);
    dispatch({
      type: TYPES.ACTION_SET_K3SCRIPTS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_SET_K3SCRIPTS_FAIL,
      payload: err.response?.data || { message: 'Error setting scripts' }
    });
  }
}; 